import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { IFeatureResponse } from '../models/IFeatureResponse';
import { Features, IGlimpseReport } from '../models/IGlimpseReport';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  constructor(private http: HttpClient) {}

  featureEnabled(name: string, areaId?: number) {
    let params = new HttpParams();
    if (areaId !== undefined) {
      params = params.set('areaId', areaId.toString());
    }

    return this.http.get<boolean>(`${environment.apiBase}/feature/${name}`, { params }).pipe(
      map(res => res),
      catchError(err => {
        console.error(err);
        return of(false);
      }),
    );
  }

  getFeatures() {
    return this.http.get<IFeatureResponse[]>(`${environment.apiBase}/features`);
  }

  dismiss(): Observable<void> {
    return this.http.post<void>(`${environment.apiBase}/features/dismiss`, null);
  }

  hasFeature(report: IGlimpseReport | null, feature: Features): boolean {
    if (!report || !report.presentationSettings) {
      //backward compatibility for reports with unset presentation settings
      return feature === Features.VideoAuditing;
    }

    if (feature === Features.CustomerCounting) {
      return (
        report.presentationSettings.features.includes(Features.CustomerCountingMatching) ||
        report.presentationSettings.features.includes(Features.CustomerCounting)
      );
    }

    return report.presentationSettings.features.includes(feature);
  }

  isAsyncMatching(report: IGlimpseReport | null): boolean {
    //reports without presentation settings predate async matching
    return !!report?.presentationSettings?.asyncMatching;
  }

  /**
   * Timeliness charts break down how promptly staff rang up what they served. A valet report has
   * neither servers nor menu categories to be timely about, so it shows none of them.
   */
  hasTimeliness(report: IGlimpseReport | null): boolean {
    return !this.hasFeature(report, Features.AnprMatching);
  }

  hasMatching(report: IGlimpseReport | null): boolean {
    if (!report || !report.presentationSettings) {
      //backward compatibility for reports with unset presentation settings
      return true;
    }

    return (
      report.presentationSettings.features.includes(Features.VideoAuditing) ||
      report.presentationSettings.features.includes(Features.CustomerCountingMatching) ||
      report.presentationSettings.features.includes(Features.AnprMatching)
    );
  }
}
